import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Mention, MentionsInput } from 'react-mentions'
import { Text } from '@chakra-ui/react'

const CustomMentionInput = forwardRef(
  ({ text, onChange, renderSuggestion, ...rest }, ref) => {
    return (
      <>
        <MentionsInput
          value={text}
          onChange={onChange}
          inputRef={ref}
          style={mentionInputStyles}
          {...rest}
        >
          <Mention
            trigger="@"
            renderSuggestion={renderSuggestion}
            style={mentionStyle}
          />
        </MentionsInput>

        <Text
          textStyle="tinyHeader"
          color="brand.textGray"
          mt="4px"
          textAlign="right"
          fontStyle="italic"
        >
          Mention people with @
        </Text>
      </>
    )
  },
)

const mentionStyle = {
  backgroundColor: '#cdddff',
  fontWeight: 'bold',
  color: '',
}

const mentionInputStyles = {
  control: {
    fontFamily: 'Nunito Sans, sans-serif',
    backgroundColor: '#fff',
    fontSize: 14,
    height: '100px',
    fontWeight: 'normal',
  },

  '&multiLine': {
    control: {},
    highlighter: {
      padding: 12,
      border: '1px solid transparent',
    },
    input: {
      padding: 12,
      border: '1px solid lightgray',
      borderRadius: '5px',
      outlineColor: '#7ca5ff',
      outlineWidth: '1px',
      outlineOffset: '-1px',
      outlineStyle: 'solid',
    },
  },

  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.1)',
      fontSize: 14,
      boxShadow: '0 0 3px rgba(0, 0, 0, .1)',
    },
    item: {
      fontFamily: 'Nunito Sans, sans-serif',
      padding: '4px 16px',
      '&focused': {
        color: 'white',
        backgroundColor: '#cdddff',
      },
    },
  },
}

CustomMentionInput.propTypes = {
  text: PropTypes.string,
  onChange: PropTypes.func,
  renderSuggestion: PropTypes.func,
  data: PropTypes.array,
}

export default CustomMentionInput
